export const projects = [
  {
    title: "Online Ticketing Database",
    subtitle: "Postgre - SQL",
    description:
      "This database project was designed to store and manage information related to various events and shows that are available for purchase all around the world.",
    image: "./sqlProject.gif",
    link: "https://github.com/adrianocrippa/ticket-database"
  },
  {
    title: "React Tracks",
    subtitle: "React and API",
    description:
      "E-commerce platform build and designerd in React, with MongoDB integration and API calls, such as authentication, products search and online payment possibility",
    image: "./eCommerce.gif",
    link: "https://github.com/adinashby-vanier-college/transactional-web-project-adrianocrippa",
  },
  {
    title: "Tic-tac-toe for Android",
    subtitle: "Mobile - XML/Java",
    description:
      "Mobile Development project, a complete tic-tac-toe game in android studio using Java with advanced features like reset button , no one wins logic, and responsive design",
    image: "./esign.gif",
    link: "https://github.com/adrianocrippa/mobile-project",
  },
  {
    title: "Eat Easier",
    subtitle: "Web Application",
    description:
      "A user-friendly recipe finder and nutrition analysis web application. The project was designed to help people explore, create and enjoy their meals. The platform integrates recipe discovery and nutrition analysis, empowering users to make informed dietary choices while satisfying their taste buds.",
    image: "./eatEasier.gif",
    link: "https://github.com/adinashby-vanier-college/web-services-project-adrianocrippa",
  },
];

export const testimonials = [
  {
    quote:
      "Lorem ipsum dolor sit amet consectetur adipisicing elit. Culpa quod necessitatibus quidem impedit facilis? Distinctio laboriosam veritatis recusandae minus. Voluptatum accusantium hic laudantium soluta ea sapiente cupiditate officia maiores itaque.",
    image: "https://avatars.githubusercontent.com/u/47254289?v=4",//FOTO TESTEMUNIAL
    name: "Adin Ashby",
    company: "Internship Coordinator",
  },
  {
    quote:
      "Adriano's exceptional skills make him a top choice for leading roles in the tech industry. Adriano is undoubtedly an asset to any team, bringing a unique blend of skills, passion, and innovation. I confidently endorse him for any role he seeks in the tech industry.",
    image: "https://avatars.githubusercontent.com/u/8085864?v=4",//FOTO TESTEMUNIAL
    name: "Mike G. Camara",
    company: "Software Engineer",
  },
];

export const skills = [
  "JavaScript",
  "React",
  "GIT",
  "Node",
  "SQL",
  "Android",
];



// WEBPACK FOOTER //
// ./src/data.js